import jobStatus from "../../../shared/variables/job-status";
import {
  FETCH_GOLFER_PROFILE_HANDICAP,
  FETCH_GOLFER_PROFILE_HANDICAP_SUCCESS,
  FETCH_GOLFER_PROFILE_HANDICAP_FAILED,
} from "../actions";

const initialState = {
  handicaps: [],
  jobStatus: jobStatus.NOT_STARTED,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_GOLFER_PROFILE_HANDICAP:
      return {
        ...state,
        handicaps: [],
        jobStatus: jobStatus.PROCESSING,
      };
    case FETCH_GOLFER_PROFILE_HANDICAP_SUCCESS:
      return {
        ...state,
        handicaps: payload,
        jobStatus: jobStatus.SUCCESS,
      };
    case FETCH_GOLFER_PROFILE_HANDICAP_FAILED:
      return {
        ...state,
        jobStatus: jobStatus.FAILED,
      };
    default:
      return state;
  }
};
